import { Suspense, useLayoutEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { getChanelAuthorisedRoutes, getUnAuthorisedRoutes } from './components/routes/channel-rouths.config'
import AppAlertComponent from './components/shared/app-alert/app-alert.component'
import FallbackUI from './components/shared/fallback-ui/fallback-page.component'
import PageNotFound from './components/shared/page-not-found-component'
import useOnlineStatus from './hooks/useOnlineStatus'
import useWindowResize from './hooks/useWindowResize'
import { AppRoutes, WebRoutes } from './components/routes/route.path'
import * as selector from './selectors/selectors'
// import LiveChatPopUpComponent from './components/live-chat/live-chat-popup-component'
// import LiveChatShareToChatLinkComponent from './components/live-chat/live-chat-share-to-chat-link-component';
import { ChannelAuthService } from './services/ChannelAuthService'
import { ChannelUserService } from './services/ChannelUserService'
import { UpdateWordpressDetails } from './actions'
import React from 'react'



const Layout = React.lazy(() => import('./components/layout/channel-layout.component'))

const App = () => {
    const dispatch = useDispatch()
    const { showAlert, alertType, alertText, closeAlert } = useOnlineStatus();
    const userRole: number = useSelector(selector.loggedInUserroleId);
    const IsWordPress: boolean = useSelector(selector.IsWordpress)
    const IsShopify: boolean = useSelector(selector.IsShopify)

    useWindowResize();

    useLayoutEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data.wordpress === "wordpress") {
                UpdateWordpressDetails(dispatch, { wordpressDomain: event.data.wordpressDomain, wordpress: true });

                // checkScriptStatus(event.data.wordpressDomain);
            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);


    //  function use full for the falkon live chat already there or not  
    const checkScriptStatus = async (WordpressDomain: string) => {
        try {
            const response = await fetch(`${WordpressDomain}/wp-json/custom/v1/check-script`);
            const data = await response.json();
            console.log("inserted..?  ", data.script_inserted === "1" ? true : false)
            // setIsScriptInserted(data.script_inserted);
        } catch (error) {
            console.error('Error checking script status:', error);
        }
    };

    return (
        <>
            {showAlert && (
                <AppAlertComponent
                    OnClose={closeAlert}
                    TextProps={() => <span>{alertText}</span>}
                    Type={alertType}
                    ShowAlert={showAlert}
                />
            )}

            <BrowserRouter>
                <Routes>
                    {/** Public Routes */}
                    {getUnAuthorisedRoutes().map(route => <Route key={route.id} path={route.path} element={<Suspense fallback={<></>}><route.component /></Suspense>} />)}

                    {/** Protected Routes */}
                    <Route path={AppRoutes.HOME_PATH} element={<Suspense fallback={<FallbackUI />}><Layout /></Suspense>}>
                        {
                            getChanelAuthorisedRoutes(userRole).map(route => route.hasSubRoutes ? route.children?.map(croute => <Route index key={croute.id} path={croute.path} element={<croute.component />} />) : <Route index key={route.id} path={route.path} element={<route.component />} />)
                        }
                        <Route path="*" element={<PageNotFound />} />
                    </Route>
                    <Route index path={AppRoutes.HOME_PATH} element={<Navigate replace to={!!ChannelAuthService.isUserLoggedIn() ? ChannelUserService.hasSysAdminRole() ? WebRoutes.CHANNELS_ORGANISATIONS : (IsWordPress || IsShopify) ? AppRoutes.CHANNELS : AppRoutes.CHANNELS_DASHBOARD : AppRoutes.CHANNELS_SIGN_IN} />} />

                    {/* <Route path={WebRoutes.LIVE_CHAT} element={<LiveChatPopUpComponent />} />

                    <Route path={WebRoutes.SHARE_TO_CHAT_LINK} element={<LiveChatShareToChatLinkComponent />} /> */}
                </Routes>
            </BrowserRouter>
        </>
    )
}

export default App
